module.exports = __webpack_public_path__ + "media/clients/alida-2x-b57989de.jpg";